(ns core.front.routing
  (:require [app.domain.branding.model :as branding-model]
            [app.front.ui.panels :as panels]
            [clojure.string :as str]
            [core.front.analytics :as analytics]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [re-frame.db :as db]
            [reitit.frontend :as reitit]
            [reitit.frontend.controllers :as rfc]
            [reitit.frontend.easy :as rfe]))



;;
;; Route events:
;;

(defn update-match [db new-match]
  (update db :route/match (fn [old-match]
                            (when new-match
                              (assoc new-match :controllers (rfc/apply-controllers (:controllers old-match) new-match))))))


(rf/reg-event-fx ::on-navigate
  (fn [{:keys [db]} [_ new-match]]
    (analytics/track-page-view new-match)
    {:db (update-match db new-match)
     :fx [[:dispatch [::panels/close-all-except-persistent]]]}))


(defn remove-nil-params [params params-to-merge remove-blanks?]
  (->> (p/filter-vals #(or (nil? %) (and remove-blanks? (str/blank? %))) params-to-merge)
       keys
       (apply dissoc params)))

;; Merges given query params to current route/match state.
;; Removes any keys present in `params-to-merge` with a `nil` value.
;; By default uses :route/push fx. Second parameter can override this (eg use :route/replace instead).
;; Third parameter (boolean) indicates whether to also remove keys with blank string values.
(rf/reg-event-fx ::merge-query-params
  (fn [{:keys [db]} [_ params-to-merge push-or-replace remove-blanks?]]
    (let [match         (get db :route/match)
          state-fx-type (or push-or-replace :route/push)]
      {state-fx-type {:route  (get-in match [:data :name])
                      :params (get-in match [:parameters :path])
                      :query  (-> (get-in match [:parameters :query])
                                  (merge params-to-merge)
                                  (remove-nil-params params-to-merge remove-blanks?))}})))

(rf/reg-event-fx ::replace-query-params
  (fn [{:keys [db]} [_ params push-or-replace]]
    (let [match         (get db :route/match)
          state-fx-type (or push-or-replace :route/push)]
      {state-fx-type {:route  (get-in match [:data :name])
                      :params (get-in match [:parameters :path])
                      :query  params}})))

;;
;; Will show not-found view by default
;;

(rf/reg-event-db ::reset-view
  (fn [db _]
    (assoc-in db [:route/match :data :view] nil)))

;;
;; Route subscriptions:
;;

(rf/reg-sub :route/match
  (fn [db _]
    (get db :route/match)))


(rf/reg-sub :route/name
  (fn [db _]
    (get-in db [:route/match :data :name])))

;;
;; Route effect handlers:
;;

(defn raw-branding []
  (branding-model/or-default (:branding @db/app-db)))

(defn- match->map [value]
  (if (keyword? value)
    {:route value}
    value))

(defn- push-reitit-fx [value]
  (let [{:keys [route params query]} (match->map value)
        branding                     (raw-branding)]
    #_{:clj-kondo/ignore [:discouraged-var]}
    (rfe/push-state route (assoc params :branding branding) query)))

(defn- replace-reitit-fx [value]
  (let [{:keys [route params query]} (match->map value)
        branding                     (raw-branding)]
    (rfe/replace-state route (assoc params :branding branding) query)))

(rf/reg-fx :route/push push-reitit-fx)
(rf/reg-fx :route/replace replace-reitit-fx)
(rf/reg-event-fx :route/push (fn [_ [_ arg]] {:route/push arg}))
(rf/reg-event-fx :route/replace (fn [_ [_ arg]] {:route/replace arg}))


(rf/reg-event-db ::save-router
  (fn [db [_ router]]
    (assoc db ::router router)))

(rf/reg-sub ::router :-> ::router)

(defn match-path-and-replace-state [router path]
  (if (str/starts-with? path "/api/v1/oauth/authorize")
    (js/window.location.replace path)
    (let [match (or (reitit/match-by-path router path)
                    (reitit/match-by-path router (str "/" (raw-branding) "/dashboard")))]
      (rfe/replace-state (-> match :data :name) (-> match :path-params) (-> match :query-params)))))

(rf/reg-fx :route/redirect-to-path
  (fn [{:keys [path router]}]
    (match-path-and-replace-state router path)))
